import { useMemo } from "react";

import { MapProjectCoordinates } from "../../../../../../../models/shared/mapProjectCoordinates";
import { GetProjectDetailsResponse as GetPublicProjectDetailsResponse } from "../../../../../../../service/publicquery";
import { GetProjectDetailsResponse } from "../../../../../../../service/query";

interface UseBasicDetailsSectionReturnData {
  mapCoordinates: MapProjectCoordinates[] | null;
  totalProjectArea: string;
}

export const useBasicDetailsSection = (
  projectDetails: GetProjectDetailsResponse | GetPublicProjectDetailsResponse
): UseBasicDetailsSectionReturnData => {
  const totalProjectArea = useMemo(
    () => (projectDetails?.areaNetHa !== null ? `${projectDetails?.areaNetHa} ha` : ""),
    [projectDetails]
  );

  return {
    mapCoordinates: projectDetails?.locationCoordinates
      ? [{ coordinate: projectDetails?.locationCoordinates, name: projectDetails.name }]
      : null,
    totalProjectArea,
  };
};
